import {
	EdgesGeometry,
	Group,
	TextureLoader,
	Mesh,
	LineSegments,
	LineBasicMaterial,
	MeshPhongMaterial,
	Material,
	BoxGeometry
} from '../../../src/js/three.module.js';

export class PaintingPlainFrame {

    constructor( rr, d, material ) {

        var self = this;

        this.$old_settings = {};
        this.$cur_settings = {};

        Object.defineProperty(this, "rr", {
            get: function () { return self.$cur_rr; },
            set: function (rr) {
                if (typeof rr == "string") {
                    rr = parseFloat(rr);
                }
                if (typeof rr == "number" && !isNaN(rr)) {
                    rr = { left: rr, top: rr, bottom: rr, right: rr };
                }

                if (typeof rr == "object") {
                    /** 20.08.2019 Otetaan käyttöön vain suurin saaduista arvoista, sillä eri kokoiset/epäsymmetriset arvot tuottavat väärin generoituja kehys/paspis -geometrioita -M */
                    var max_rr = Math.max(0, rr.left || 0, rr.top || 0, rr.right || 0, rr.bottom || 0);
                    var differs = false;
                    try {
                        if (!isNaN(rr.left) && rr.left != max_rr)
                            differs = true;
                        if (!isNaN(rr.top) && rr.top != max_rr)
                            differs = true;
                        if (!isNaN(rr.right) && rr.right != max_rr)
                            differs = true;
                        if (!isNaN(rr.bottom) && rr.bottom != max_rr)
                            differs = true;
                        if (differs) {
                            console.error("Oeuvre has different size in sides of canvas/frame. Using only largest one. Different sizes not implemented yet!", JSON.stringify(rr));
                            angular.element(document.body).injector().get("Notification").warning({ title: "Failed to use saved oeuvre canvas/frame -options", message: "Oeuvre has different size in sides of canvas/frame. Using only largest one. Different sizes not implemented yet!" });
                        }
                    } catch (err) { }
                    rr.left = rr.top = rr.right = rr.bottom = max_rr;


                    self.$old_settings = self.$cur_settings;
                    self.$old_rr = angular.copy(self.rr);
                    self.$cur_rr = angular.copy(rr);
                    self.$cur_settings = self.toJSON();
                    self.$$rr = self.$cur_rr.left;
                }
            }
        });
        Object.defineProperty(this, "d", {
            get: function () { return self.$cur_d; },
            set: function (d) {
                self.$old_settings = self.$cur_settings;
                self.$old_d = self.d;
                self.$cur_d = d;
                self.$cur_settings = self.toJSON();
            }
        });
        Object.defineProperty(this, "color", {
            get: function () { return "#" + self.material.color.getHexString(); },
            set: function (color) {
                self.$old_settings = self.$cur_settings;
                self.$old_color = self.color;
                self.$cur_color = "#" + self.material.color.set(color).getHexString();
                self.$cur_settings = self.toJSON();
            }
        });

        if (arguments.length == 1 && typeof rr == "object") {
            material = rr.material;
            d = rr.d;
            rr = rr.rr;
        }

        this.d = d || 0;
        this.rr = rr;

        if (typeof material == "string")
            material = { color: material };

        if (!(material instanceof Material))
            material = new LineBasicMaterial(material);

        this.material = material;
        this.color = "#" + material.color.getHexString();
    }
    toJSON() {
        return {
            color: this.$cur_color,
            rr: this.$cur_rr,
            d: this.$cur_d
        };
    }
}

export class PaintingCanvas extends Group {

    constructor(sgeo, sw, sh, d, rr, material) {

        super();

        this.sw = sw;
        this.sh = sh;

        this.d = d;
        this.rr = null;

        this.$wireframe = null;

        if (typeof rr == "number") {
            this.rr = { top: rr, bottom: rr, left: rr, right: rr };
        } else if (Array.isArray(rr)) {

            /** Käytetään CSS-tyylistä listausta [ kaikki ], [ top/bottom, left/right ], [ top, left/right, bottom ], [ top, right, bottom, left ]
             * @link https://drafts.csswg.org/css-box-3/#margin */
            if (rr.length == 1) {
                this.rr = { top: rr[0], bottom: rr[0], left: rr[0], right: rr[0] };
            } else if (rr.length == 2) {
                this.rr = { top: rr[0], bottom: rr[0], left: rr[1], right: rr[1] };
            } else if (rr.length == 3) {
                this.rr = { top: rr[0], bottom: rr[2], left: rr[1], right: rr[1] };
            } else if (rr.length == 4) {
                this.rr = { top: rr[0], bottom: rr[2], left: rr[3], right: rr[1] };
            }
        } else if (typeof rr === "object") {
            if (typeof rr.top === "number" && typeof rr.bottom === "number" && typeof rr.left === "number" && typeof rr.right === "number") {
                this.rr = rr;
            }
        }
        if (!this.rr)
            throw new TypeError("Invalid Argument: Invalid frame parameter");

        this.w = this.sw + this.rr.left + this.rr.right;
        this.h = this.sh + this.rr.top + this.rr.bottom;

        this.material = material;
        this.sgeo = sgeo.clone();

        /** 20.08.2019 Jätetty korjaamatta. Kehyksen/Paspis -geometrioiden koot generoidaan väärin, kun mitat ovat epäsymmetriset/eri arvoja -M */
        var fmap = [
            // frame,          oeuvre,
            [[[[4, 5, 6, 7], [0, 1, 2, 3]], "x", this.rr.left], [["y", [0, 1], this.rr.top], ["y", [2, 3], -this.rr.bottom]]],
            [[[[0, 1, 2, 3], [4, 5, 6, 7]], "x", -this.rr.right], [["y", [4, 5], this.rr.top], ["y", [6, 7], -this.rr.bottom]]],
            [[[[6, 7, 2, 3], [4, 5, 0, 1]], "y", this.rr.top], [["x", [4, 5], -this.rr.right], ["x", [0, 1], this.rr.left]]],
            [[[[4, 5, 0, 1], [6, 7, 2, 3]], "y", -this.rr.bottom], [["x", [6, 7], -this.rr.right], ["x", [2, 3], this.rr.left]]], // bottom
        ];

        for (var i = 0; i < 4; i++)
            this.add(new Mesh(new BoxGeometry(this.sw, this.sh, 2 * d), this.material));

        this.$wireframe = new Group();

        for (let i = 0; i < fmap.length; i++) {

            for (let e = 0; e < fmap[i][0][0][0].length; e++) {
                this.children[i].geometry.vertices[fmap[i][0][0][0][e]][fmap[i][0][1]] =
                    this.sgeo.vertices[fmap[i][0][0][1][e]][fmap[i][0][1]];
                this.children[i].geometry.vertices[fmap[i][0][0][1][e]][fmap[i][0][1]] += fmap[i][0][2];
            }

            for (let a = 0; a < fmap[i][1].length; a++) {
                this.children[i].geometry.vertices[fmap[i][1][a][1][0]][fmap[i][1][a][0]] += fmap[i][1][a][2];
                this.children[i].geometry.vertices[fmap[i][1][a][1][1]][fmap[i][1][a][0]] += fmap[i][1][a][2];
            }

            for (let e in this.children[i].geometry.vertices) {
                if (this.children[i].geometry.vertices[e].z < 0) {
                    this.children[i].geometry.vertices[e].z = 0;
                }
            }

            this.children[i].verticesNeedUpdate = true;

            this.$wireframe.add(new LineSegments(
                new EdgesGeometry(this.children[i].geometry),
                new LineBasicMaterial({ color: 0xffff00, linewidth: 2 })
            ));

        }
        //	this.add( this.$wireframe );
    }
}

export class PaintingFrame extends PaintingCanvas {
    constructor(sgeo, sw, sh, d, rr, material) {
        super(sgeo, sw, sh, d, rr, material);
    }
}   